angular.module('TetherApp').controller(
    'TicketController',
    [
        '$http',
        '$mdDialog',
        'ticketService',
        function ($http, $mdDialog, ticketService) {
            let self = this;
            this.clientEid = '';
            this.search = '';
            this.ticketStatus = 'help';
            this.ticketEscalatedText = '';

            this.initDate = function (taskDate) {
                if (taskDate) {
                    this.task.date = new Date(taskDate);
                } else {
                    this.task.date = new Date();
                }
            };

            this.dateSelectionChange = function () {
                if (this.task.date_selection !== 'custom') {
                    let dayDiff = 0;
                    if (this.task.date_selection === 'tomorrow') {
                        dayDiff = 1;
                    }
                    if (this.task.date_selection === '7_days') {
                        dayDiff = 7;
                    }
                    if (this.task.date_selection === '28_days') {
                        dayDiff = 28;
                    }
                    let nowDate = new Date();
                    this.task.date = new Date(nowDate.getFullYear(), nowDate.getMonth(), (nowDate.getDate() + dayDiff), 0, 0, 0, 0);
                }
            };

            this.closeTicket = function (taskEid) {
                if (window.confirm('Are you sure you want to close ticket "' + taskEid + '"?')) {
                    $http.post('/ticket-closed/' + taskEid, { client: this.clientEid }, {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    }).then(function () {
                        window.location = window.location;
                    });
                }
            };

            this.toggleTaskContainer = function (ticketEid) {
                $('#' + ticketEid + '_task_container').toggle();
            };

            this.toggleMessageContainer = function (ticketEid) {
                $('#' + ticketEid + '_message_container').toggle();
            };

            let DialogController = function ($mdDialog) {
                let dCtrl = this;
                dCtrl.parent = self;
                dCtrl.message = undefined;

                dCtrl.hide = function () {
                    $mdDialog.hide();
                };

                dCtrl.cancel = function () {
                    window.location = window.location;
                    $mdDialog.cancel();
                };
            };

            self.statusPopup = function (ev, client, ticket) {
                DialogController.$inject = ['$mdDialog'];
                $mdDialog.show({
                    controller: DialogController,
                    controllerAs: 'popupController',
                    bindToController: true,
                    templateUrl: '/' + client + '/ticket/' + ticket + '/status-popup',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true
                });
            };

            this.setStatus = function (client, ticket) {
                ticketService.setStatus(client, ticket, this.ticketStatus, this.ticketEscalatedText)
                    .then(
                        function(){
                            this.ticketStatus = '';
                            this.ticketEscalatedText = '';
                            window.location = window.location;
                        },
                        onError
                    );
            };

            let onSuccess = function () { window.location = window.location; };

            let onError = function(reason) {

            };

            this.delete = function (ticket) {
                if (window.confirm('Are you sure you want to delete ticket "' + ticket.toUpperCase() + '"?')) {
                    $http.delete('/' + this.clientEid + '/ticket/' + ticket)
                        .then(function () {
                            window.location = window.location;
                        });
                }
            }

        }
    ]
);
